// AutoGenerated
export class AltSezonModel {
    sezonModelId!: string;
    isim!: string;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}